import { useTheme } from "@/hooks/useTheme";
import { useI18n } from "@/lib/i18n.jsx";

/**
 * Calofay brand logo — used across the app.
 * Arabic mode: uses the "كالوفاي" wordmark image (calofay-logo.webp / -dark.webp).
 * English mode: uses a text-based "Calofay" logo composed of the same orange
 *   mark PNG + English text (no baked-in English wordmark WebP available yet).
 */
export default function Logo({ size = 56, className = "" }) {
  const { theme } = useTheme();
  const { lang } = useI18n();

  if (lang === "en") {
    const mark = size * 0.9;
    const textSize = Math.round(size * 0.55);
    return (
      <div
        className={`inline-flex items-center gap-2 select-none ${className}`}
        style={{ height: size }}
        data-testid="calofay-logo"
      >
        <img
          src="/calofay-mark.webp"
          alt=""
          width={200}
          height={200}
          style={{ height: mark, width: mark }}
          className="rounded-[22%]"
          draggable={false}
          fetchpriority="high"
          decoding="async"
        />
        <span
          className={`font-black tracking-tight ${theme === "dark" ? "text-white" : "text-neutral-900"}`}
          style={{ fontSize: textSize, letterSpacing: "-0.02em" }}
        >
          Calofay
        </span>
      </div>
    );
  }

  const src = theme === "dark" ? "/calofay-logo-dark.webp" : "/calofay-logo.webp";
  return (
    <img
      src={src}
      alt="كالوفاي"
      width={400}
      height={267}
      style={{ height: size, width: "auto" }}
      className={`select-none pointer-events-none ${className}`}
      data-testid="calofay-logo"
      draggable={false}
      fetchpriority="high"
      decoding="async"
    />
  );
}
